// src/utils/web-3-modal.ts

import { defaultWagmiConfig } from '@web3modal/wagmi/react/config';
import { baseSepolia, base } from 'wagmi/chains';

// --- Project ID ---
// Get projectId at https://cloud.walletconnect.com
export const projectId = process.env.NEXT_PUBLIC_PROJECT_ID;

if (!projectId) throw new Error('Project ID is not defined');

// --- Metadata ---
// Metadata for the wallet connection
const metadata = {
  name: 'ChadAI',
  description: 'ChadAI',
  url: 'https://chadi.org/',
  icons: ['https://avatars.githubusercontent.com/u/37784886'],
};

// --- Chains ---
// Supported chains for the wallet connection
const chains = [baseSepolia, base] as const;

// --- Wagmi Config ---
// Export the default Wagmi configuration with SSR enabled
export const config = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
  ssr: true,
});
